import { Drawer } from "antd";
import styled from "styled-components";

export const Title = styled.h1`
  font-family: Asap;
  font-weight: bold;
  font-size: 20px;
  text-align: left;
  color: #4b4b4b;
  margin: 0;
`;

export const Container = styled.div`
  height: 100%;
  overflow-y: auto;
  padding: 28px 5px 0px 5px;

  .formContent {
    width: 100%;
    padding: 0px 24px;
    padding-bottom: 20px;
  }

  .rowLabel {
    margin: 8px 0px;
  }

  span.subTitle {
    font-size: 14px;
    color: #000;
    margin-bottom: 10px;
  }

  label {
    color: #9074bf;
    font-size: 14px;
    font-weight: bold;
    &.error {
      color: #d44c4c;
      margin-left: 15px;
    }
  }

  .ant-select {
    width: 100%;
  }

  .sectionTitle {
    font-size: 16px;
    font-weight: bold;
    color: #9074bf;
    margin: 20px 0px 10px 0px;
    padding-bottom: 8px;
    border-bottom: 2px solid #e8e8e8;
  }

  .pageHeader {
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-bottom: 20px;
    padding: 0 24px;

    .pageTitle {
      font-size: 18px;
      font-weight: bold;
      font-family: "Asap", sans-serif;
      color: #9074bf;
    }
  }
`;

export const Footer = styled.div`
  border-top: 1px solid #e8e8e8;
  width: 100%;
  padding: 10px 24px;
  margin-top: 20px;
  background: #fff;
  position: sticky;
  bottom: 0;
  z-index: 10;

  .buttonsDiv {
    display: flex;
    align-items: center;
    justify-content: flex-end;

    button:first-of-type {
      margin-right: 12px !important;
    }
  }

  .ant-row-flex {
    margin: 0;
  }
`;

export const DrawerContainer = styled(Drawer)`
  .ant-drawer-body {
    padding: 24px 0px 10px 0px;
  }

  .drawerForm {
    width: 100%;
    padding: 0px 24px;
    padding-bottom: 20px;
    min-height: -moz-calc(100vh - 165px);
    min-height: -webkit-calc(100vh - 165px);
    min-height: calc(100vh - 165px);
  }

  .rowLabel {
    margin: 8px 0px;
  }

  label {
    color: #9074bf;
    font-size: 14px;
    font-weight: bold;
    margin-left: 15px;
    &.error {
      color: #d44c4c;
      margin-left: 15px;
    }
  }

  .ant-select {
    width: 100%;
  }
`;

export const DrawerDetailsContainer = styled(Drawer)`
  .ant-drawer-body {
    padding: 24px 0px 10px 0px;
  }

  .drawerForm {
    width: 100%;
    padding: 0px 24px;
    padding-bottom: 20px;
    min-height: -moz-calc(100vh - 165px);
    min-height: -webkit-calc(100vh - 165px);
    min-height: calc(100vh - 165px);
  }

  .rowLabel {
    margin: 8px 0px;
  }

  label {
    color: #9074bf;
    font-size: 14px;
    font-weight: bold;
    &.error {
      color: #d44c4c;
    }
    &.sectionTitle {
      font-size: 16px;
      color: #9074bf;
      margin: 20px 0 8px 0;
      padding-bottom: 8px;
      border-bottom: 2px solid #e8e8e8;
      display: block;
      margin-left: 0;
    }
  }

  .ant-select {
    width: 100%;
  }
`;
